import { Pipe, PipeTransform } from '@angular/core';
import {trialLicenseCategoryMap, trialLicenseRuleMap} from '../shareModel';

@Pipe({
  standalone: false,
  name: 'trialLicenseCode'
})
export class TrialLicenseCodePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (Number.isInteger(value)) {
      if (args === 'Category' && trialLicenseCategoryMap.hasOwnProperty(value)) {
        return trialLicenseCategoryMap[value];
      } else if (args === 'Rule' && trialLicenseRuleMap.hasOwnProperty(value)) {
        return trialLicenseRuleMap[value];
      }
    }
    return value;
  }

}
